import { Text } from '@agro-club/agroclub-shared'
import { useAFormHandler } from 'analytics/hooks'
import { useFormik } from 'formik'
import { refetchFunc } from 'modules/domain/common/hooks'
import { endpoints } from 'modules/endpoints'
import { apiClient } from 'modules/utils/httpClient'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import FormSelectShared from 'views/components/FormSelectShared'
import { ResponsiveModal } from 'views/components/ResponsiveModal/ResponsiveModal'
import { SharedModalContent } from 'views/components/SharedModal'

type Props = {
  onClose: () => void
  parentId: string
  parentName: string
  refetch: refetchFunc
}

export const AddBranchModal: FC<Props> = ({ onClose, parentId, parentName, refetch }) => {
  const { t } = useTranslation(['company'])

  const { formHandler, formProgress } = useAFormHandler()

  const formik = useFormik<{ childCompany?: string }>({
    initialValues: {
      childCompany: undefined,
    },
    onSubmit: formHandler(
      async () => {
        await apiClient.patch(endpoints.company(formik.values.childCompany), { parent: parentId })
      },
      {
        onSuccess: async () => {
          await refetch()
          onClose()
        },
      },
    ),
  })

  return (
    <ResponsiveModal
      id="addChildCompany"
      onClose={onClose}
      title={t('addChildCompany')}
      onConfirm={formik.submitForm}
      progress={formProgress}
      size="small"
      disabled={!formik.values.childCompany}
    >
      <SharedModalContent>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <Text>{`${t('addChildCompanyText')} ${parentName}`}</Text>
          <FormSelectShared
            hideLabel
            endpoint={endpoints.company()}
            formik={formik}
            fieldName="childCompany"
            placeholder=""
            searchField="search"
          />
        </div>
      </SharedModalContent>
    </ResponsiveModal>
  )
}
